import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from 'react-router-dom';
import {withRouter} from "react-router";

import Navigation from './Nav-bar-menu';
import logo from "../../static/assets/GPRlogo.png"



const NavComponent = (props) => {
  const dynamicLink = (route, linkText) => {
    return (
      <div className='nav-link-wrapper'>
        <NavLink to={route} activeClassName='nav-link-active'>
          {linkText}
        </NavLink>
      </div>
    )
  };
  const onClickMenu = () => {
    return (
      <div className='onClick-menu'>
        <Navigation/>
      </div>
    )
  }

  return (
    <React.StrictMode>
      <div className='nav-bar'>
        <div className='nav-bar-logo'>
          <a href="/"><img src={logo} /></a>
        </div>
        {/* <div className='nav-bar-icon'>
          <FontAwesomeIcon icon="fa-solid fa-helmet-safety" />
        </div> */}
        <div className='nav-bar-wrapper'>

          {dynamicLink("/", "Home")}
          {dynamicLink("/about", "About")}
          {dynamicLink("/contact", "Contact")}

        </div>
        <div className='nav-bar-popup'>
          {onClickMenu()}
        </div>
      </div>
    </React.StrictMode>  
  )
};

export default withRouter(NavComponent);